// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1RUXN","title":"Header_title__2gYs1","left":"Header_left__2RMbX","clinicName":"Header_clinicName__36Hnn"};